import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'

import { capitalizeFirstLetter } from './utils'
import { MenuType } from './menu'

import UserContext from '../../../contexts/UserContext';
import {
    Tab,
    TabProps,
    Dimmer,
    Loader,
    Button,
    Dropdown,
    Checkbox,
    Icon,
    Input,
    Select,
    Divider,
    Form,
} from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { saveMenuItem, updateMenuItem, deleteMenuItem, listCommunityMenus } from '../../../services/community';
import MenuItem from './menuItem';
import MenuItemForm from './menuItemForm';

import './style.less';

const Menu = () => {
    const [lastUpdated, setLastUpdated] = useState(Date.now());
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
            profile: { _id: userId },
        },
    } = useContext(UserContext);

    const [menuDate, setMenuDate] = useState(new Date());
    const [loading, setLoading] = useState(false);

    const menuItems = [
        {
            dish: 'Quinoa Salad with Eggs',
            type: 'Breakfast',
            time: 'Thursday, 24/02/21',
        },
        {
            dish: 'Ravioli Pasta with Penne sauce',
            type: 'Lunch',
            time: 'Thursday, 24/02/21',
        },
        {
            dish: 'Baked oats crisps with tea',
            type: 'Snack',
            time: 'Thursday, 24/02/21',
        },
        {
            dish: "Spaghetti and Ceaser's salad",
            type: 'Dinner',
            time: 'Thursday, 24/02/21',
        },
    ];

    const menuList = () => {
        return (
            <>
                {/* {menuItems.map((menuItem) => {
                    return <MenuItem menuItem={menuItem} />;
                })} */}
            </>
        );
    };

    const panes = [
        {
            menuItem: 'Active',
            render: () => <Tab.Pane className="pane"> {menuList()} </Tab.Pane>,
        },
        {
            menuItem: 'History',
            render: () => (
                <Tab.Pane className="pane">
                    <DatePicker maxDate={new Date()} customInput={<Input />} />
                    {menuList()}
                </Tab.Pane>
            ),
        },
    ];

    const menuTypes = [
        {
            key: 'breakfast',
            text: 'Breakfast',
            value: 'breakfast',
            content: 'Breakfast',
        },
        {
            key: 'lunch',
            text: 'Lunch',
            value: 'lunch',
            content: 'Lunch',
        },
        {
            key: 'dinner',
            text: 'Dinner',
            value: 'dinner',
            content: 'Dinner',
        },
        {
            key: 'snack',
            text: 'Snack',
            value: 'snack',
            content: 'Snack',
        },
        {
            key: 'alternative',
            text: 'Alternative',
            value: 'alternative',
            content: 'Alternative',
        },
    ];

    const saveMenu = async (menuItem) => {
        try {
            await saveMenuItem(userId, menuItem);
            fetchCommunities();
        } catch (e) {
            console.log(e);
        }
    };

    const updateMenu = async (menuItem) => {
        try {
            await updateMenuItem(userId, menuItem);
            fetchCommunities();
        } catch (e) {
            console.log(e);
        }
    };
    const deleteMenu = async (menuId) => {
        try {
            await deleteMenuItem(userId, menuId);
            await fetchCommunities();
        } catch (e) {
            console.log(e);
        }
    };

    const [communityMenuList , setCommunityMenuList] = useState<MenuType[]>([]);

    const fetchCommunities = async (filters = {
        // The number of days displayed in one calendar view is 42 days (7 x 6 days)
        // 43+43 days is declared as the window below (and not 42+42), to not leave out dates in edge cases
        // 43*24*60*60*1000 is the num of milliseconds in 43 days
        // The present default value of filters is overwritten when a narrower date window is available, like in the handleMonthChange function
        timestamp: {
            $gte: Date.now() - (43*24*60*60*1000),
            $lte: Date.now() + (43*24*60*60*1000)
        }
    }) => {
        if (process.env.REACT_APP_PLATFORM==='community') {
            try {
                setLoading(true)
                //Extend this to take page number
                const selectedResident = listOfResidents[activeRegistrantsIndexes[0]]
                // const communities = await listCommunityMenus(userId);
                let menus = []
                if (selectedResident.Facility) {
                    menus = await listCommunityMenus(selectedResident.Facility, filters)
                }
                setCommunityMenuList(menus);
                setLoading(false)
            } catch (e) {
                console.log(e);
            }
        }
    };

    useEffect(() => {
        fetchCommunities();
    }, [activeRegistrantsIndexes]);

    const getColor = (category) => {
        switch(category) {
            case 'breakfast':
                return '#3D9CBF'
            case 'lunch':
                return '#69B546'
            case 'dinner':
                return '#EAC31F'
            case 'snack':
                return '#E98530'
            case 'alternative':
                return '#E98530'
            default:
                return '#3D9CBF'
        }
    }

    const handleMonthChange = async (payload) => {
        await fetchCommunities({
            timestamp: {
                $gte: payload.start.getTime(),
                $lte: payload.end.getTime()
            }
        })
    }

    return (
        <div className=" food-menu">
            {/* <div className="create-menu">
                <Button basic primary>
                    <Icon name="add" /> Create menu item
                </Button>
            </div> */}

            {/* <div className="filters-dropdown">
                <Dropdown item simple text="Filters">
                    <Dropdown.Menu className="left">
                        <Dropdown.Item>
                            <Checkbox
                                name="Breakfast"
                                label="Breakfast"
                                // onChange={handleCheckBoxChange}
                                // checked={feedFilters.messages}
                                toggle
                            ></Checkbox>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Checkbox
                                name="Lunch"
                                label="Lunch"
                                // onChange={handleCheckBoxChange}
                                // checked={feedFilters.messages}
                                toggle
                            ></Checkbox>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Checkbox
                                name="Dinner"
                                label="Dinner"
                                // onChange={handleCheckBoxChange}
                                // checked={feedFilters.messages}
                                toggle
                            ></Checkbox>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Checkbox
                                name="Snacks"
                                label="Snacks"
                                // onChange={handleCheckBoxChange}
                                // checked={feedFilters.messages}
                                toggle
                            ></Checkbox>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <Checkbox
                                name="Alternative"
                                label="Alternative"
                                // onChange={handleCheckBoxChange}
                                // checked={feedFilters.messages}
                                toggle
                            ></Checkbox>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div> */}

            {/* <Tab menu={{ secondary: true, pointing: true }} panes={panes} /> */}

            {/* <h2>Create Menu</h2> */}
            <h2>Menu</h2>
            {/* <div className="create-menu">
                <Form>
                    <div className="fields">
                        <DatePicker
                            maxDate={new Date()}
                            selected={menuDate}
                            onChange={(date) => setMenuDate(date)}
                            placeholderText="Date"
                            customInput={<Input placeholder="Date" />}
                        />
                        <Input placeholder="Dish Name" />
                        <Dropdown options={menuTypes} selection defaultValue={menuTypes[0].value}></Dropdown>
                        <Button onClick={saveMenuItem}>Save</Button>
                    </div>
                </Form>
            </div> */}
            {/* <MenuItemForm
                menuItem={{ dateString: new Date().toDateString(), category: 'breakfast', alexaReadableCollection: [] }}
                saveHandler={saveMenu}
                cancelHandler={undefined}
            /> */}
            <Divider />
            <Dimmer active={loading} inverted>
                <Loader active={loading} />
            </Dimmer>
            <div className="menu-calendar-view menu-calendar">
                <FullCalendar
                    plugins={[ dayGridPlugin ]}
                    initialView="dayGridMonth"
                    timeZone="local"
                    // weekends={false}
                    events={[
                        ...communityMenuList.map((event) => {
                            const timeSlots = {
                                breakfast: 8,
                                lunch: 12,
                                dinner: 20,
                                snack: 18,
                                alternative: 22
                            }
                            return {
                                title: event.text
                                    ? `${capitalizeFirstLetter(event.category)}:  ${event.text.replace(
                                        /(<([^>]+)>)/gi,
                                        '',
                                    )}`
                                    : '',
                                start: new Date(event.dateString).getTime() + timeSlots[event.category] * 60,
                                displayEventTime: false,
                                id: event._id,
                                backgroundColor: getColor(event.category),
                                classNames: [`category-${event.category}`]
                            }
                        })
                    ]}
                    datesSet={handleMonthChange}
                />
            </div>

            {/* {communityMenuList.map((menuItem) => {
                const { _id } = menuItem;
                return <MenuItem menuItem={menuItem} key={_id} updateHandler={updateMenu} deleteHandler={deleteMenu} />;
            })} */}
            {/* {menuList()} */}
        </div>
    );
};

export default Menu;
